var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-if=\"currentStepNumber() == 3\" class=\"row title-bar title-bar-light\">\n<div class=\"row\">Step 3 Success</div>\n</div>\n<div ng-if=\"currentStepNumber() == 4\" class=\"row title-bar title-bar-light\">\n<div class=\"row\">Step 4 Success</div>\n</div>\n";
var id1="app/includes/storage-booking-input-summary.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;